import _ from "lodash";

export function submitPayloadFromValues(values) {
  return {
    destinationObj: values.destinationObj,
    country: _.last(
      _.get(values, "destinationObj.destination_meta.destination", "").split(
        "-"
      )
    ),
    category: _.get(values, "category", ""),
    price_quartile: _.get(values, "price_quartile", 0),
    order_by: _.get(values, "order_by", "score"),
    website_api_key: _.get(values, "website_api_key", ""),
  };
}
